/*
 * FortaNexus HU — localise the Releasit order-summary tax note.
 * (File name kept from the Croatian build because layout/theme.liquid loads it
 * by this name; the content is the Hungarian version.)
 *
 * Releasit renders the note in English ("Including 12.00 in taxes") inside its
 * COD form summary. There is no setting for it and the node is re-rendered by
 * the app whenever the cart total changes, so this polls and rewrites it.
 *
 * Hungarian build (Ft / hu-HU / "Ebből ÁFA:"), restored from the Croatian copy:
 * only the label and the Intl locale/currency differ -- HUF has no decimals, so
 * 0 fraction digits. The polling interval, idempotency guard, regex, number
 * parsing and fallback branch are unchanged.
 *
 * The Hungarian Releasit form renders its own wording, "Tartalmaz 3529.13 adót"
 * (raw decimals), so that form is matched too and rewritten the same way.
 */
setInterval(() => {
  document.querySelectorAll(".rsi-total-summary-taxes-note").forEach((element) => {
    const text = element.textContent.trim();

    // Already translated — skip
    if (text.startsWith("Ebből ÁFA:")) return;

    // Capture whatever is between "Including" and "in taxes" (or "Tartalmaz" and "adót")
    const match = text.match(/Including\s+(.+?)\s+in\s+taxes/i) || text.match(/Tartalmaz\s+(.+?)\s+adót/i);

    if (match) {
      const rawAmount = match[1];
      // "3529.13" / "3,529.13" -> dot decimal; "3.529,13" / "3 529,13" -> comma decimal
      let digits = rawAmount.replace(/[^\d.,-]/g, '');
      if (/^\d{1,3}(\.\d{3})+$/.test(digits)) digits = digits.replace(/\./g, ''); // "3.529" = thousands
      digits = /,\d{1,2}$/.test(digits) ? digits.replace(/\./g, '').replace(',', '.') : digits.replace(/,/g, '');
      const cleanNumber = parseFloat(digits);

      if (!isNaN(cleanNumber)) {
        // HUF is shown without decimals (min set too, so older engines do not throw)
        const formattedAmount = new Intl.NumberFormat('hu-HU', {
          style: 'currency',
          currency: 'HUF',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }).format(cleanNumber);

        element.textContent = `Ebből ÁFA: ${formattedAmount}`;
      } else {
        element.textContent = `Ebből ÁFA: ${rawAmount} Ft`;
      }
    }
  });
}, 500);
